'use client';

/**
 * Catches errors in the root layout. Replaces the entire root when active.
 * Must define its own <html> and <body>.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body style={{ margin: 0, padding: 0, backgroundColor: '#eeeced', fontFamily: 'system-ui, sans-serif' }}>
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
          }}
        >
          <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#236434', marginBottom: 8 }}>
            Something went wrong
          </h1>
          <p style={{ color: '#64748b', fontSize: 14, marginBottom: 24, textAlign: 'center', maxWidth: 400 }}>
            The app encountered an error. Try again or refresh the page.
          </p>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              padding: '12px 24px',
              borderRadius: 8,
              border: 'none',
              backgroundColor: '#236434',
              color: 'white',
              fontWeight: 600,
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
